import { Link } from 'react-router';
import { Box, Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { UserProfession } from '~/enums/UserProfession';
import { ProfessionalRating } from '../ProfessionalRating';
import { IProfessionalCardUser } from '../../interfaces';

interface IProfessionalCardDetailsLegacyProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetailsLegacy = ({
  user,
}: IProfessionalCardDetailsLegacyProps) => {
  const { id, fullname, profession, rating, isAvailable } = user;
  const unavailableColorText = isAvailable ? colors.neutral[500] : colors.neutral[300];

  return (
    <Column justify="center" style={{ marginLeft: 24 }}>
      <Row align="center" gap={2}>
        <Typography
          as="span"
          bold
          size="heading_4"
          numberOfLines={1}
          style={{ maxWidth: 240, opacity: isAvailable ? 1 : 0.5 }}
        >
          {fullname}
        </Typography>

        <Row align="center" justify="center" gap={2}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />
          <Box style={{ width: 2, height: 20, backgroundColor: colors.neutral[600] }} />
          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
              <Typography as="span" bold color={colors.secondary[500]} size="heading_4">
                Profile
              </Typography>
            </Link>
          ) : (
            <Typography as="span" bold color={colors.secondary[200]} size="heading_4">
              Profile
            </Typography>
          )}
        </Row>
      </Row>
      <Column>
        <Typography as="span" color={unavailableColorText}>
          {UserProfession.getName(profession || '')}
        </Typography>
      </Column>
    </Column>
  );
};
